import React from 'react';
import ReactTooltip from 'react-tooltip';

const InstafeedHeader = ({
  // handleWidgetCancel,
  // openGetCodeModel,
  state,
  profile,
  // authToken,
  handleCancelCnf,
  handleUpdateCnf,
  // createWidget,
  // handleInputchange,
  handleScreenSize,
  // redirectPreview,
  // wdtLoginCreateWidget,
  // confirmForResetWidget,
  // widgetId
}) => {

  const handleSupport = () => {
    window.open('https://support.wisernotify.com/install-wiser-instafeed-in-shopify-store/', '_blank').focus();
  };

  return (
    <div className="header-editor">
      <div className="header-editor-part header-editor-right">
        {
          profile && profile.brand ?
            profile.brand.lg ?
              <img className="logo-icon" src={profile.brand.lg} alt="notifly" />
              :
              <img className="logo-icon" src='https://storage.googleapis.com/wiserimg/user_img/default_company.png' alt="notifly" />
            :
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="19" viewBox="0 0 35 19">
              <g id="Group_27865" data-name="Group 27865" transform="translate(75.503 -1134.629)">
                <path id="Union_15" data-name="Union 15" d="M18.713,14.956,10.186,3.8a2.307,2.307,0,0,1-.449-1.783,2.358,2.358,0,0,1,1-1.557,2.6,2.6,0,0,1,3.51.529l6.509,8.519,1.753-2.3a2.6,2.6,0,0,1,3.514-.529,2.36,2.36,0,0,1,1,1.557,2.307,2.307,0,0,1-.449,1.783l-3.63,4.753a2.5,2.5,0,0,1-.242.271,2.416,2.416,0,0,1-.488.441,2.6,2.6,0,0,1-3.51-.529Zm-9.706,0L.48,3.8A2.307,2.307,0,0,1,.031,2.014a2.358,2.358,0,0,1,1-1.557,2.6,2.6,0,0,1,3.51.529l8.526,11.159a2.307,2.307,0,0,1,.449,1.783,2.36,2.36,0,0,1-1,1.557,2.6,2.6,0,0,1-3.511-.529Z" transform="translate(-74.999 1136.748)" fill="#212121" stroke="rgba(0,0,0,0)" strokeMiterlimit="10" strokeWidth="1"></path><path id="Polygon_10" data-name="Polygon 10" d="M3.017.311A.772.772,0,0,1,3.625,0a.721.721,0,0,1,.6.3l2.753,3.8a.725.725,0,0,1,.048.765.772.772,0,0,1-.669.41L.73,5.356a.718.718,0,0,1-.656-.391.733.733,0,0,1,.072-.77Z" transform="translate(-46.829 1134.634) rotate(35.025)" fill="#645cfc"></path>
              </g>
            </svg>
        }

        {
          state.isEditWidget == true &&
          <div className="btn-group-dissave">
            <button className="nf-btn  tbl-seehty-btn nf-btn-noneBdr nf-btn-minW wg-btn-discard" onClick={() => handleCancelCnf()} data-tip data-for="tltpdcrd">
              Discard
            </button>
            <ReactTooltip id="tltpdcrd" aria-haspopup='true' role='example'>
              <p>Discard your changes</p>
            </ReactTooltip>
            <button className="nf-btn nf-btn-green nf-btn-noneBdr nf-btn-minW wg-btn-save" onClick={() => handleUpdateCnf()} data-tip data-for="tltpsvcrd">
              Save
            </button>
            <ReactTooltip id="tltpsvcrd" aria-haspopup='true' role='example'>
              <p>You must click 'Save' to apply your update</p>
            </ReactTooltip>
          </div>

        }
        {/* <input placeholder="Wall name" className="wdgt-name-input" value={state.wdsc ? state.wdsc : ''} onChange={(e) => handleInputchange('wdsc', e.target.value)} /> */}
      </div>
      <div className="header-editor-part header-editor-middle">
        {/* <div className="reset-block" >
          <span className="reset-link" onClick={() => confirmForResetWidget()}>Reset</span>
        </div> */}
        <div className="header-editor-screenicon">
          <div className={!state.isMobileScreen ? 'screen-size active' : 'screen-size'} onClick={() => handleScreenSize('desktop')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 17 17.139">
              <g id="streamline-icon-computer-screen-1_20x20" data-name="streamline-icon-computer-screen-1@20x20" transform="translate(-0.215 -1.286)">
                <path id="Path_21056" data-name="Path 21056" d="M.714,1.786h16V14.308h-16Z" transform="translate(0 0)" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                <path id="Path_21057" data-name="Path 21057" d="M8.374,14.643,7.143,18.121" transform="translate(-0.89 -0.335)" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                <path id="Path_21058" data-name="Path 21058" d="M11.429,14.643l1.231,3.478" transform="translate(-1.483 -0.335)" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                <path id="Path_21059" data-name="Path 21059" d="M5.714,18.214H13.1" transform="translate(-0.692 -0.428)" fill="none" stroke="#212121" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
              </g>
            </svg>
          </div>
          <div className={state.isMobileScreen ? 'screen-size active' : 'screen-size'} onClick={() => handleScreenSize('phone')}>
            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="17" viewBox="0 0 11 17">
              <g id="streamline-icon-catergories-phone_20x20" data-name="streamline-icon-catergories-phone@20x20" transform="translate(-3.686 -0.214)">
                <path id="Path_21053" data-name="Path 21053" d="M3.571.714h10v16h-10Z" transform="translate(0.615 0)" fill="none" stroke="#656565" stroke-linecap="round" stroke-linejoin="round" stroke-width="1" />
                <path id="Path_59829" data-name="Path 59829" d="M11.036,17.75a1,1,0,1,1,1-1A1,1,0,0,1,11.036,17.75Z" transform="translate(-1.85 -3.036)" fill="#656565" />
              </g>
            </svg>
          </div>
        </div>
        <div className='preview-wrap'>
          <span className='preview-item'>
            Preview
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12.001 12">
              <path id="Path_59586" data-name="Path 59586" d="M7.5-14.964a.64.64,0,0,1-.455-.187.64.64,0,0,1-.187-.455.64.64,0,0,1,.187-.455.64.64,0,0,1,.455-.187h3.858a.64.64,0,0,1,.455.187.64.64,0,0,1,.187.455v3.857a.64.64,0,0,1-.187.455.64.64,0,0,1-.455.187.64.64,0,0,1-.455-.187.64.64,0,0,1-.187-.455v-2.3l-5.358,5.3a.587.587,0,0,1-.442.2.587.587,0,0,1-.442-.2.615.615,0,0,1-.188-.442.615.615,0,0,1,.188-.442l5.334-5.334ZM0-13.892a1.609,1.609,0,0,1,.429-1.071A1.609,1.609,0,0,1,1.5-15.392h3a.64.64,0,0,1,.455.187.64.64,0,0,1,.187.455.64.64,0,0,1-.187.455.64.64,0,0,1-.455.187h-3a.231.231,0,0,0-.214.214v8.144a.231.231,0,0,0,.214.214H9.643a.231.231,0,0,0,.215-.214v-3a.64.64,0,0,1,.187-.455.64.64,0,0,1,.455-.187.64.64,0,0,1,.455.187.64.64,0,0,1,.187.455v3a1.609,1.609,0,0,1-.429,1.071,1.609,1.609,0,0,1-1.071.429H1.5A1.609,1.609,0,0,1,.429-4.678,1.609,1.609,0,0,1,0-5.749Z" transform="translate(0 16.249)" fill="#3cca73" />
            </svg>
          </span>
        </div>
      </div>



      <div className="header-editor-part header-editor-left">
        <span className='tb-rghmenu-bdrleft tb-rghmenu-bdrright'></span>
        {/* <div className="btn-add-notification btn-infoweb" id='' onClick={() => handleSupport()}>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path id="Path_58079" data-name="Path 58079" d="M-20444,7704a8.01,8.01,0,0,1,8-8,8.015,8.015,0,0,1,8,8,8.013,8.013,0,0,1-8,8A8.008,8.008,0,0,1-20444,7704Zm1.744-.026a6.289,6.289,0,0,0,6.162,6.28h.092a6.268,6.268,0,0,0,6.254-6.28,6.263,6.263,0,0,0-6.254-6.254A6.265,6.265,0,0,0-20442.256,7703.976Zm5.648,3.222v-1.185h1.18v1.185Zm.025-2.027a4.318,4.318,0,0,1,.154-1.021,1.986,1.986,0,0,1,.652-.718l.348-.287a1.179,1.179,0,0,0,.309-.308,1.084,1.084,0,0,0,.221-.657,1.254,1.254,0,0,0-.242-.759.931.931,0,0,0-.852-.354h0a.567.567,0,0,0-.088,0,1,1,0,0,0-.816.431,1.591,1.591,0,0,0-.256.754h-1.242a2.16,2.16,0,0,1,.934-1.821,2.5,2.5,0,0,1,1.387-.426,2.825,2.825,0,0,1,1.789.564,1.753,1.753,0,0,1,.684,1.544,1.769,1.769,0,0,1-.287,1.016,3.3,3.3,0,0,1-.709.657l-.363.272a1.184,1.184,0,0,0-.391.605,2.1,2.1,0,0,0-.072.513Z" transform="translate(20444 -7695.998)" fill="#8392a5" />
          </svg>
        </div> */}
        <div className='wdgt-btn-getcode btn-getcode-prvside' onClick={() => handleSupport()}>
          <a class="nf-btn nf-btn-default nf-btn-noneBdr  nf-btn-minW" >
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8 0C10.1931 0 12.2118 0.897196 13.6573 2.34268C15.1028 3.78816 16 5.78193 16 8C16 10.2181 15.1028 12.2118 13.6573 13.6573C12.2118 15.1028 10.1931 16 8 16C5.78193 16 3.78816 15.1028 2.34268 13.6573C0.897196 12.2118 0 10.2181 0 8C0 5.78193 0.897196 3.78816 2.34268 2.34268C3.78816 0.897196 5.78193 0 8 0ZM7.17757 12.6355V5.48287H8.79751V12.6355H7.17757ZM7.20249 3.36449H8.79751V4.98442H7.20249V3.36449ZM12.9097 3.09034C11.6386 1.84424 9.919 1.04673 8 1.04673C6.081 1.04673 4.33645 1.84424 3.09034 3.09034C1.81931 4.33645 1.04673 6.081 1.04673 8C1.04673 9.919 1.81931 11.6636 3.09034 12.9097C4.33645 14.1807 6.081 14.9533 8 14.9533C9.919 14.9533 11.6386 14.1807 12.9097 12.9097C14.1558 11.6636 14.9283 9.919 14.9283 8C14.9283 6.081 14.1558 4.33645 12.9097 3.09034Z" fill="white" />
            </svg>Support</a>
        </div>
      </div>

    </div>
  );
};

export default InstafeedHeader;


// WEBPACK FOOTER //
// ./src/components/Widget/InstafeedHeader.js